import cn from 'classnames';
import { type ReduxUser } from 'models';
import { Avatar, Title, Text } from 'ui';

type P = {
  viewer: ReduxUser;
  isCollapsed: boolean;
};

const Navigation = ({ viewer, isCollapsed }: P) => {
  return (
    <div className="navigation-user-avatar">
      <div className={cn('navigation-user-avatar__dash', { 'navigation-user-avatar__dash--collapsed': isCollapsed })}>
        <Avatar size={isCollapsed ? 44 : 56} photo={viewer.profile_photo?.url} />
      </div>
      {isCollapsed ? null : (
        <div className="navigation-user-avatar__text">
          <Title
            item={{
              level: 5,
            }}
          >
            {viewer.name}
          </Title>
          <Text
            item={{
              type: 'secondary',
            }}
          >
            {viewer.email}
          </Text>
        </div>
      )}
    </div>
  );
};

export default Navigation;
